const ContentTypeAutoImportConfigService = {
    OneDrive: { id: 13, name: 'OneDrive' },
    Email: { id: 14, name: 'Email' },
    FileSystem: { id: 15, name: 'FileSystem' },
    EmailOffice365: { id: 20, name: 'EmailOffice365' },
    ExternalApplications: { id: 21, name: 'ExternalApplications' },
    DocECM: { id: 1, name: 'Doc.ECM' },
    GoogleDrive: { id: 22, name: 'Google Drive' },
};

function getContentTypeAutoImportConfig() {
    return Object.values(ContentTypeAutoImportConfigService).map(service => ({
        id: service.id,
        name: this.$t(service.name)
    }));
}

export default { ContentTypeAutoImportConfigService, getContentTypeAutoImportConfig };